import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const TIER = { HOT: "bg-destructive/10 text-destructive", WARM: "bg-amberbrand/10 text-amberbrand", COLD: "bg-slate-200 text-slate-500" };

export default function Prospects() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/accelerator-prospects").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageTitle title="Accelerator Prospects" subtitle="Scored membership users — upsell HOT prospects into the $2,500 Accelerator" />
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="prospects-table">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
              <tr>{["Name", "Email", "Score", "Tier", "Leads", "Refs", "Training", "Placed"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50" data-testid={`prospect-${r.id}`}>
                  <td className="px-4 py-3 font-medium text-navy">{r.name}</td>
                  <td className="px-4 py-3 text-slate-600">{r.email}</td>
                  <td className="px-4 py-3 font-semibold text-navy">{r.score}</td>
                  <td className="px-4 py-3"><Badge className={`${TIER[r.tier]} hover:${TIER[r.tier]}`}>{r.tier}</Badge></td>
                  <td className="px-4 py-3 text-slate-600">{r.leads}</td>
                  <td className="px-4 py-3 text-slate-600">{r.refs}</td>
                  <td className="px-4 py-3 text-slate-600">{r.training}</td>
                  <td className="px-4 py-3 text-slate-600">{r.placed}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={8} className="px-4 py-10 text-center text-slate-400">No prospects yet. Scores appear as members become active.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
